import React from 'react'
import SellerHeader from '../../components/SellerHeader'
import ProductForm from '../../components/ProductForm'

const EditProductForm = () => {
  return (
    <div>
        <SellerHeader />
        <ProductForm />
    </div>
  )
}

export default EditProductForm